import Image from "../fragments/Image";
import Gallery from "../fragments/Gallery";
import { useReveal } from '../hooks/UseReveal';
import { useState, useEffect } from "react";

export default function Text({ block }) {

    const textRevealRef = useReveal({ once: true });

    if (block.alignment === 'left') {
        return (
            <div className={`c-page__block c-page__block--text`}>
                <div className={`l-grid`}>
                    <div className={`l-grid__col l-grid__col--m-7-12 l-grid__col--l--12 c-transition-in`} ref={textRevealRef}>
                        <div className="scope-text scope-text--two-columns" dangerouslySetInnerHTML={{ __html: block.text || '' }} />
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className={`c-page__block c-page__block--text`}>
                <div className={`l-grid`}>
                    <div className={`l-grid__col l-grid__col--m-7-12 l-grid__col--m-push-5-12 l-grid__col--l-8-12 l-grid__col--l-push-4-12 c-transition-in`} ref={textRevealRef}>
                        <div className="scope-text scope-text--two-columns" dangerouslySetInnerHTML={{ __html: block.text || '' }} />
                    </div>
                </div>
            </div>
        );
    }
}